import React from 'react'
import logo from '@assets/images/logo.png'
import { useForm, Controller } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { LinkUnderline, ErrorForm, InputForm, Button } from '@components/index'
import { AuthContext, AuthContextType } from '@contexts/authContext'
import { useYupValidation } from '@hooks/index'
import { loginSchema } from '@yupSchemas/index'
import { IAuthContext, IAuthLogin } from '@interfaces/index'
import { AuthService, errorHandler } from '@services/index'
import { toast } from 'react-toastify'

export default function Login(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()
    const { logIn } = React.useContext(AuthContext) as AuthContextType
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthLogin>({
        resolver: useYupValidation(loginSchema),
    })

    async function login(values: IAuthLogin): Promise<void> {
        setIsLoading(true)
        try {
            const response = await AuthService.login(values)
            if (response.accessToken) {
                const loggedUser: IAuthContext = {
                    user: {
                        name: response.user.name,
                        email: response.user.email,
                        imageUrl: response.user.imageUrl,
                    },
                    accessToken: response.accessToken,
                    refreshToken: response.refreshToken,
                }
                logIn(loggedUser)
                navigate('/')
            }
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="box-login">
            <div className="login__background">
                <div className="login__content">
                    <div className="login__images">
                        <img src={logo} alt="Logo CNA construtora" className="login__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Área restrita exclusiva para administradores CNA</h4>
                    <form id="login__form" onSubmit={handleSubmit(login)}>
                        <Controller
                            name="email"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm size='small' placeholder="E-mail" label="E-mail" name="email" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.email?.message} />
                        <Controller
                            name="password"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm size='small' type="password" label="Senha" placeholder="Senha" name="password" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.password?.message} />
                        <div className="box-buttons-login">
                            <LinkUnderline placeholder="Esqueci minha senha" onClick={() => navigate('/forgot-pass')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Entrar" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
